'use client';

import {
	InfoMediaResourcesIcon,
	AirportServiceIcon,
	HangarIcon,
	AboutIcon,
	FeesIcon,
} from '@/ui';
import { PageRoutes } from '../app/pages/domain/constants/PageRoutes';
import {
	EntryPointsIconWrapper,
	EntryPointsWrapper,
	EntryPoint,
} from '../newsroom/ui/NewsroomEntryPoints';

const mediaEntryPoints = [
	{
		href: PageRoutes.PilotInfo,
		icon: 'info',
		label: 'Pilot Info',
	},
	{
		href: PageRoutes.OxdAirportServices,
		icon: 'airport-services',
		label: 'Airport Services',
	},
	{
		href: PageRoutes.OxdHangarOfficeLeasing,
		icon: 'hangar-office-leasing',
		label: 'Hangar/Office leasing',
	},
	{
		href: PageRoutes.OxdAbout,
		icon: 'about',
		label: 'About',
	},
	{
		href: PageRoutes.OxdFees,
		icon: 'fees',
		label: 'Fees',
	},
];

function getLinkButtonIcon(icon: string) {
	switch (icon) {
		case 'info':
			return <InfoMediaResourcesIcon aria-hidden />;
		case 'airport-services':
			return <AirportServiceIcon aria-hidden />;
		case 'hangar-office-leasing':
			return <HangarIcon aria-hidden />;
		case 'about':
			return <AboutIcon aria-hidden />;
		case 'fees':
			return <FeesIcon aria-hidden />;
		default:
			return <span>Icon not found!</span>;
	}
}

export default function OxdAirportEntryPoints() {
	return (
		<EntryPointsWrapper>
			{mediaEntryPoints.map((link) => (
				<EntryPoint key={link.label} href={link.href} aria-label={link.label}>
					<EntryPointsIconWrapper oxdThemed>
						{getLinkButtonIcon(link.icon)}
					</EntryPointsIconWrapper>
					{link.label}
				</EntryPoint>
			))}
		</EntryPointsWrapper>
	);
}
